module.exports = __webpack_public_path__ + "static/eorn-logo-71c3c4fc6175b8be763ffbbf6840d565.jpg";